import { UserOutlined, HomeOutlined, GlobalOutlined, TagOutlined, FlagOutlined, IdcardOutlined, CopyOutlined } from "@ant-design/icons";
import { Avatar, Tag, Card, Tooltip, Typography } from "antd";
import React from "react";
import { Button, Col, Modal, ModalHeader, ModalBody, ModalFooter, Row } from "reactstrap";
import 'react-toastify/dist/ReactToastify.css';

const { Title } = Typography;
const DetailPaymentAccount = ({ modal, setModal, toggle, selectedPaymentAccount, currentuser }) => {
    
    const { accountNumber, type, amount, totalAmount, date } = selectedPaymentAccount || {};

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
    };

    const returnAccountType = () => {
        if (type == 'WALLET')
            return <Tag color="blue"> {type} </Tag>
        return <Tag color="orange"> {type} </Tag>
    }



    return (
        <Modal isOpen={modal} toggle={toggle} centered backdrop="static" style={{ maxWidth: "650px" }}>
            <ModalHeader className="bg-info-subtle p-3" toggle={toggle}>
                <span>Détail du compte de versement</span>
            </ModalHeader>

            <ModalBody>

                <Card title="Informations générales" style={{ marginBottom: 20, boxShadow: "0 2px 10px rgba(0,0,0,0.1)" }}>
                    <Row gutter={16}>
                        <div className="">
                            <div className='row d-flex, align-items-center justify-content-between' >
                                <Title level={5} className='col-xl-4 text-start'>Numéro du compte</Title>
                                <span className='col-xl-8 fs-5 text-end'> {accountNumber} </span>
                            </div>
                            <hr style={{ width: '100%' }} />
                            <div className='row d-flex, align-items-center bg-yellow'>
                                <Title level={5} className='col-xl-4 text-start'>Type du compte</Title>
                                <span className='col-xl-8 fs-5 text-end'> {returnAccountType()} </span>
                            </div>
                            <hr style={{ width: '100%' }} />
                            <div className='row d-flex, align-items-center bg-yellow'>
                                <Title level={5} className='col-xl-4 text-start'>Montant total</Title>
                                <span className='col-xl-8 fs-5 text-end'> {totalAmount} XOF</span>
                            </div>
                            <hr style={{ width: '100%' }} />
                            <div className='row d-flex, align-items-center bg-yellow'>
                                <Title level={5} className='col-xl-4 text-start'>Date de création</Title>
                                <span className='col-xl-8 fs-5 text-end'> {formatDate(date)} </span>
                            </div>
                            <hr style={{ width: '100%' }} />
                            <div className='row d-flex, align-items-center bg-yellow'>
                                <Title level={5} className='col-xl-4 text-start'>Associations</Title>
                                <span className='col-xl-8 fs-5 text-end'> Non défini</span>
                            </div>
                        </div>
                    </Row>
                </Card>
            </ModalBody>

            <ModalFooter>
                <Button color="danger" onClick={() => setModal(false)}>Fermer</Button>
            </ModalFooter>
        </Modal>
    );
};

export default DetailPaymentAccount;
